import styled, { AnyStyledComponent } from 'styled-components';
import FONTS from '../../style/fonts';
import COLORS from '../../style/universal.color';
import {
  LabelProps,
  RadioButtonSpanProps,
  HiddenRadioButtonProps,
} from './radioGroup.types';

export const Wrapper: AnyStyledComponent = styled.div`
  display: inline-block;
`;

export const RadioButton: AnyStyledComponent = styled.span<RadioButtonSpanProps>`
  position: relative;
  height: 12px;
  width: 12px;
  margin-right: 10px;
  border: 1px solid ${COLORS.mlbGrey3};
  border-radius: 50%;
  box-sizing: border-box;
  &:after {
    display: none;
    content: "";
    position: absolute;
    top: 1px;
    left: 1px;
    width: 8px;
    height: 8px;
    background-color: ${({ theme }) => (theme.dark ? COLORS.linkBlueOnDark : COLORS.linkBlue)};
    border-radius: 50%;
  }
`;

export const Label: AnyStyledComponent = styled.label<LabelProps>`
  position: relative;
  display: flex;
  margin-bottom: 15px;
  color: ${({ theme, disabled }) => (theme.dark ? (disabled ? COLORS.mlbGrey5 : COLORS.mlbGrey2) : (disabled ? COLORS.mlbGrey3 : COLORS.mlbGrey6))};
  font-family: ${FONTS.primaryFont};
  font-size: 15px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  user-select: none;
  align-items: center;
  line-height: 1;
`;

export const HiddenRadioButton: AnyStyledComponent = styled.input.attrs({
  type: 'radio'
})<HiddenRadioButtonProps>`
  position: absolute;
  height: 0;
  width: 0;
  opacity: 0;
  &:checked + ${RadioButton} {
    border-color: ${({ theme }) => (theme.dark ? COLORS.linkBlueOnDark : COLORS.linkBlue)};
    &:after {
      display: block;
    }
  }
  &:disabled + ${RadioButton} {
    border-color: ${({ theme }) => (theme.dark ? COLORS.mlbGrey5 : COLORS.mlbGrey3)};
  }
  &:focus + ${RadioButton} {
    box-shadow: 0 0 0 1px ${COLORS.tabFocusColor};
  }
`;
